import { useEffect } from 'react';

import { useAppServices } from '@/app/AppServicesContext';
import { CosmosLayer } from '@/features/cosmos/CosmosLayer';
import { JourneyRail } from '@/features/journey/JourneyRail';
import { SiteFooter } from '@/features/footer/SiteFooter';
import { SiteHeader } from '@/features/navigation/SiteHeader';
import { HomePage } from '@/pages/HomePage';

import styles from './App.module.css';

export function App() {
  const { motion } = useAppServices();

  useEffect(() => motion.bindAnchorLinks(document), [motion]);

  return (
    <CosmosLayer>
      <a className={styles.skipLink} href="#contenu">
        Aller au contenu
      </a>
      <SiteHeader />
      <main id="contenu">
        <HomePage />
      </main>
      <SiteFooter />
      {/* Après les chapitres : ses repères se calent sur la mise en page finale. */}
      <JourneyRail />
    </CosmosLayer>
  );
}
